'use strict'

module.exports = {
  copySync: require('./copy-sync')
}



//////////////////
// WEBPACK FOOTER
// ./packages/truffle-compile/~/fs-extra/lib/copy-sync/index.js
// module id = 2037
// module chunks = 0 1